import Header from "../components/utils/Header";
import banner from '../media/banner/booking.webp';
import Nav from "../components/utils/Nav";
import Footer from "../components/utils/Footer";
import  Form  from "../components/book/Form";
import { useTranslation } from 'react-i18next';

const Booking = () => {

    const { t } = useTranslation("global")
    return <>
        <Nav active="booking" />
        <Header title={t("booking.title")} img={banner} />
        <Form />
        <Footer />
    </>
}

export default Booking;